// src/pages/Public/VerifyStudentEmail.jsx
import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from '../../utils/axios';
import './VerifyStudentEmail.css';

function VerifyStudentEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`/student-requests/verify-email/${token}`);
      setStatus('success');
      setMessage(response.data.msg);
      
      setTimeout(() => {
        navigate('/student-login');
      }, 3000);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.msg || 'Doğrulama başarısız oldu.');
    }
  };

  return (
    <div className="verify-email-page">
      <div className="verify-container">
        {status === 'loading' && (
          <div className="verify-loading">
            <div className="loading-spinner">✉️</div>
            <h2>Email Doğrulanıyor...</h2>
            <p>Lütfen bekleyin, email adresiniz doğrulanıyor.</p>
          </div>
        )}

        {status === 'success' && (
          <div className="verify-success">
            <div className="success-icon">✅</div>
            <h2>Email Doğrulandı!</h2>
            <p>{message}</p>
            <p className="redirect-message">Giriş sayfasına yönlendiriliyorsunuz...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="verify-error">
            <div className="error-icon">❌</div>
            <h2>Doğrulama Başarısız</h2>
            <p>{message}</p>
            <div className="error-actions">
              <Link to="/student-request" className="resend-btn">
                Yeniden Kayıt Ol
              </Link>
              <Link to="/" className="home-link">
                Ana Sayfa
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VerifyStudentEmail;